import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';

export class VendorInsuranceRawDto {
    emailCacheId: number;
    emailAccount: string;
    folder: string;
    fileName: string;
    fileBase64String: string;
    fileId: number;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    effectiveDate: Date;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    endDate: Date;

    fileTypeCode: string;
    fileDescripton: string;
}
